import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EdibleEssentialOils.scss";
import Breadcrumb from "../../../../components/Breadcrum";
import { Link } from "react-router-dom";
import Notfound from "../../../Notfound/Notfound";

// const products = [
//   {
//     id: 1,
//     title: "Edible Oils",
//     description: "Black & Yellow Mustard Seed Oils, Groundnut & Sesame Oils",
//     image: "./assets/img/edible-oil/pouring-300x300.png",
//   },
//   {
//     id: 2,
//     title: "Food Products",
//     description: "Puffed Rice, Phool Makhana, Soya Chunks & Soya Chaap, Poha",
//     image: "./assets/img/edible-oil/nuts-300x300.png",
//   },
//   {
//     id: 3,
//     title: "Essential Oils",
//     description: "Castor Oil, Neem Oil & Kalonji Oil",
//     image: "./assets/img/edible-oil/essential-oil-300x300.png",
//   },
//   {
//     id: 4,
//     title: "Spices",
//     description: "All kinds of spices used in Indian Kitchens",
//     image: "./assets/img/edible-oil/grinding-300x300.png",
//   },
// ];

// const oilProducts = [
//   {
//     category: "Mustard Oil",
//     title: "Netaji Kachi Ghani Yellow Mustard Oil 1 Litre Bottle",
//     imgSrc: "https://www.dohrniiexim.com/oil/EDIBLE%20600x450%20B%20(1).jpg",
//   },
//   {
//     category: "Groundnut Oil",
//     title: "Netaji Double Filtered Groundnut Oil 1 Liter Bottle",
//     imgSrc: "https://www.dohrniiexim.com/oil/EDIBLE%20600x450%20A%20(1).jpg",
//   },
//   {
//     category: "Groundnut Oil",
//     title: "Netaji Double Filtered Groundnut Oil 5 Litre Jar",
//     imgSrc: "https://www.dohrniiexim.com/oil/EDIBLE%20600x450%20(1).jpg",
//   },
// ];

const EdibleEssentialOils = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <Breadcrumb
        title="Edible Essential Oils"
        backgroundImage={"./assets/img/contact-banner.png"}
        height="40vh"
      ></Breadcrumb> */}

      {/* <div className="banner" id="banner-1366873636">
        <div className="banner-inner">
          <div className="banner-bg">
            <img
              src="./assets/img/edible-oil/edible.jpg"
              alt="Edible Oil Banner"
              className="bg-img"
            />
          </div>
          <div className="banner-layers">
            <div className="text-box" id="text-box-305528193">
              <div className="text-box-content">
                <div className="text-inner">
                  <h1>Ashoka Oil Industries</h1>
                  <h3>Since 1975</h3>
                  <p>
                    47 years of Experience in manufacturing Various Kinds of
                    Edible Oils, Oil Cakes &amp; Food Products.
                  </p>
                  <Link to={'/about'} className="button primary">
                    About Us
                  </Link>
                  {/* <a href="#shop" className="button primary outline">
                    Shop Now
                  </a> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Discover Section */}
      {/* <section className="edible-essential-oils py-12 bg-gray-100 text-center">
        <div className="container mx-auto px-6 lg:px-12">
          <h2 className="text-3xl font-bold mb-4">Discover Our Legacy</h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-8">
            Established in 1975, Ashoka Oil Industries has embarked on a
            remarkable journey spanning over four decades. Today, we proudly
            stand as India’s foremost producer and exporter of Oil Seeds &
            Edible Oils. Our extensive product range encompasses Mustard Oil,
            Groundnut Oil, Sesame Oil, along with a diverse array of food
            products and spices. Our oils are meticulously crafted and marketed
            under the trusted brand name, NETAJI®.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <div
                key={product.id}
                className="edible-essential-oils-card bg-white rounded-xl shadow-md p-6"
              >
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-20 h-20 mx-auto mb-4"
                />
                <h3 className="text-xl font-semibold mb-2">{product.title}</h3>
                <p className="text-gray-600">{product.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* <section className="edible-essential-oils-slider py-10 bg-gray-100 text-center">
        <div className="container mx-auto">
          <h2 className="text-2xl font-bold">Our Products</h2>
          <p>
            Explore our range of premium edible oils and culinary essentials,
            designed to inspire your kitchen creativity and elevate your
            culinary experience.
          </p>
          <Slider {...settings}>
            {oilProducts.map((product, index) => (
              <div key={index} className="p-4">
                <div className="bg-white shadow-lg rounded-lg p-4 border-radious-5">
                  <img
                    src={product.imgSrc}
                    alt={product.title}
                    className="w-full h-48 object-cover rounded"
                  />
                  <div className="mt-4">
                    <p className="text-sm uppercase text-gray-500">
                      {product.category}
                    </p>
                    <h3 className="text-lg font-semibold">{product.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section> */}
      {/* <div className="container oil-footer">
        <div className="flex flex-col lg:flex-row items-center">
          {/* Text Content Section 
          <div className="lg:w-7/12 p-6">
            <section className="bg-gray-100 p-8 rounded-lg shadow-md">
              <h2 className="text-2xl font-bold mb-4">
                Custom Branding & Exports
              </h2>
              <p className="text-gray-700 mb-6">
                For more than 40 years, we’ve been a leading global exporter of
                high-quality oil products, continually refining our processes
                and expanding to meet the evolving demands of the global market.
                In addition, we offer Original Brand Manufacturing (OBM)
                solutions, allowing us to collaborate with partners and create
                custom products that meet their unique requirements.
              </p>
              <Link
               to={'/'}
                className="bg-white text-blue-600 font-semibold py-2 px-4 border border-blue-600 rounded-lg hover:bg-blue-600 hover:text-white transition"
              >
                Export Markets
              </Link>
            </section>
          </div>

          {/* Image Section 
          <div className="lg:w-5/12 p-6">
            <div className="relative w-full h-64 lg:h-full rounded-lg overflow-hidden shadow-md">
              <img
                src="https://ashokaoilindustries.com/wp-content/uploads/18.jpg"
                alt="Custom Branding & Exports"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div> */}
      <Notfound></Notfound>
    </>
  );
};

export default EdibleEssentialOils;
